<template>
    <div class="change-phone-container">
        <!-- 顶部导航栏 -->
        <div class="nav-bar">
            <img src="../assets/left-icon.png" alt="back" class="back-icon" @click="goBack" />
            <div class="nav-title">修改电话</div>
            <div class="nav-placeholder"></div>
        </div>

        <!-- 电话输入卡片 -->
        <div class="phone-card">
            <div class="input-group">
                <label class="input-label">电话号码</label>
                <div class="input-wrapper">
                    <input type="tel" v-model="phoneNumber" placeholder="" class="phone-input" maxlength="11" />
                    <img v-if="phoneNumber" src="../assets/close-icon.png" alt="clear" class="clear-icon"
                        @click="clearPhone" />
                </div>
            </div>
        </div>

        <!-- 保存按钮 -->
        <button class="save-btn" @click="handleSave">保存</button>
    </div>
</template>

<script>
import { systemProfile } from '../api/apiList/system';

export default {
    name: 'ChangePhone',
    data() {
        return {
            phoneNumber: ''
        };
    },
    mounted() {
        const profileData = JSON.parse(localStorage.getItem('profileData'));
        if (profileData && profileData.phone) {
            this.phoneNumber = profileData.phone;
        }
    },
    methods: {
        goBack() {
            this.$router.back();
        },
        clearPhone() {
            this.phoneNumber = '';
        },
        async handleSave() {
            if (!this.phoneNumber) {
                this.$toast('请输入电话号码')
                return;
            }
            if (!/^1[3-9]\d{9}$/.test(this.phoneNumber)) {
                this.$toast('请输入正确的手机号码')
                return;
            }
            let info = await systemProfile({
                phone: this.phoneNumber
            })
            if (info.id) {
                localStorage.setItem('profileData', JSON.stringify(info))
                this.$toast('修改电话成功')
            }
        }
    }
};
</script>

<style scoped>
.change-phone-container {
    width: 100%;
    min-height: 100vh;
    background-color: #000;
    color: #fff;
    padding: 0;
}

/* 顶部导航栏 */
.nav-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    position: sticky;
    top: 0;
    background-color: #000;
    z-index: 100;
}

.back-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.nav-title {
    font-size: 17px;
    font-weight: 500;
    color: #fff;
}

.nav-placeholder {
    width: 20px;
}

/* 电话输入卡片 */
.phone-card {
    background-color: #1a1a1a;
    border-radius: 16px;
    padding: 20px 20px 0;
    margin: 0 20px 20px;
}

.input-group {
    padding: 0 0 20px;
}

.input-label {
    display: block;
    font-size: 15px;
    color: #999;
    margin-bottom: 5px;
}

.input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.phone-input {
    width: 100%;
    background: transparent;
    border: none;
    border-bottom: 1px solid #333;
    outline: none;
    color: #fff;
    font-size: 15px;
    padding: 10px 30px 10px 0;
}

.phone-input::placeholder {
    color: rgba(255, 255, 255, 0.3);
}

.clear-icon {
    position: absolute;
    right: 0;
    width: 16px;
    height: 16px;
    opacity: 0.5;
    cursor: pointer;
}

/* 保存按钮 */
.save-btn {
    height: 50px;
    background: linear-gradient(180deg, #36D8AF 0%, #10BDA7 100%);
    border: none;
    border-radius: 25px;
    color: #000;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    position: fixed;
    bottom: 20px;
    left: 20px;
    right: 20px;
}

.save-btn:active {
    opacity: 0.8;
}
</style>
